<div class="avia-card ng-card-content" (click)="goToDetails()">
  <app-avia-card-badges [flightType]="itinerary.flightType" [isBestPrice]="isBestPrice" [legs]="itinerary.legs"/>

  <div class="avia-flights">
    @for (leg of itinerary.legs; track $index) {
      <app-avia-card-fly [leg]="leg"/>
    }
  </div>

  @if (isShowSeatInfo) {
    <div class="remind">{{ seatInfo }}</div>
  }

  <div class="avia-footer">
    <div>
      <div class="avia-price">
        {{ price.totalPrice.amount | priceFormat }} <span>{{ price.totalPrice.currency_sign }}</span>
      </div>
      @if (price.cashback) {
        <div class="cashback">{{ translations.cashback }} {{ price.cashback.amount | priceFormat }}</div>
      }
    </div>
    <button type="button" class="btn btn-blue btn-select-avia">{{ translations.aviaDetails }}</button>
  </div>
</div>
